(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-hero"]) return;
  try {
    
	const heroSection = document.querySelector('.about-hero');
	const heroImages = heroSection.querySelectorAll('.object-fit');
	const headingUl = heroSection.querySelector('ul');
	const headingUlLi = headingUl.querySelectorAll('li');
	const headingUlLiHeight = headingUlLi[0].offsetHeight;
	const headingUlLiIncrement = 0.2;// opacity increment between each steps

	const heroScroll = () => {
		headingUlLi.forEach((item, i) => {
			let opacityItem = 1 - headingUlLiIncrement*i;
			let opacityBaseline = (this.scrollY/headingUlLiHeight)*headingUlLiIncrement;

			item.style.opacity = (
				opacityItem + opacityBaseline > 1
					? 1 : opacityItem + opacityBaseline > 0
						? opacityItem + opacityBaseline
						: 0
				).toFixed(2);
		});

		setTimeout(() => {
			let activeImageIndex = Math.floor(heroImages.length - (headingUl.offsetHeight - window.scrollY) / (headingUl.offsetHeight / heroImages.length));

			heroImages.forEach((item, i) => {
				(i == activeImageIndex) 
					? item.classList.add('is-active')
					: item.classList.remove('is-active');
			});

			(window.scrollY > headingUl.offsetHeight)
				? root.classList.add('about-hero-is-scrolled', 'header-is-black')
				: root.classList.remove('about-hero-is-scrolled', 'header-is-black');
		}, 1);
	}

	heroScroll();
	window.addEventListener('scroll', _.throttle(heroScroll, 100));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frontpage-hero"]) return;
  try {
    
	// media
	const heroSection = document.querySelector('.frontpage-hero');
	const heroContent = heroSection.querySelector('.hero-content');
	const medias = heroSection.querySelectorAll('.media');

	if(medias.length > 1) {
		setInterval(() => {
			for (let i = 0; i < medias.length; i++) {
				let el = medias[i];

				if(el.classList.contains('is-active')) {
					let index = (i == medias.length - 1)
						? 0 : i + 1;
					let mediaActive = medias[index];

					el.classList.remove('is-active');
					mediaActive.classList.add('is-active');

					if(mediaActive.classList.contains('text-is-white')) {
						root.classList.add('header-is-white-full');
						heroContent.classList.add('cr-white')
					} else {
						root.classList.remove('header-is-white-full');
						heroContent.classList.remove('cr-white');
					}

					// exit loop once the new is-active class has been assigned
					break;
				}
			}
		}, mediaLoopInterval * 1000); 
	}

	// timezones
	const setTimeZone = () => {
		(heroSection.querySelector('.timezone-sydney'))
			? heroSection.querySelector('.timezone-sydney').innerHTML =
				new Date().toLocaleString('en-US', {
					timeZone: 'Australia/Sydney',
					hour: 'numeric',
					minute: 'numeric',
					hour12: true
				})
			: '';

		(heroSection.querySelector('.timezone-los-angeles'))
			? heroSection.querySelector('.timezone-los-angeles').innerHTML =
				new Date().toLocaleString('en-US', {
					timeZone: 'America/Los_angeles',
					hour: 'numeric',
					minute: 'numeric',
					hour12: true
				})
			: '';
	}

	setTimeZone();
	setInterval(setTimeZone, 60 * 1000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-header"]) return;
  try {
    
// header anchor link
const headerAnchors = document.querySelectorAll('.js-header-anchor');

if (headerAnchors.length > 0) {
	headerAnchors.forEach(item => {
		let targetPage = '/' + item.dataset.targetPage;
		let targetSection = '#' + item.dataset.targetSection;
		item.href = targetPage + targetSection;
	});
}

// menu toggle
document.addEventListener('click', (e) => {
	if(e.target &&
		e.target.classList.contains('js-menu-toggle') ||
		e.target.closest('.js-menu-toggle')) {
		if(root.classList.contains('menu-is-active')) {
			root.classList.remove('menu-is-active');
		} else {
			root.classList.add('menu-is-active');
			root.classList.remove('minicart-is-active');
		}
	}

	if(root.classList.contains('menu-is-active') &&
		e.target &&
		!e.target.classList.contains('js-menu-toggle') &&
		!e.target.closest('.js-menu-toggle') &&
		!e.target.classList.contains('global-menu') &&
		!e.target.closest('.global-menu')) {
		root.classList.remove('menu-is-active');
	}
});

// search input desktop
const searchD = document.querySelector('.d-menu-search');
const searchInputD = searchD.querySelector('input');
const searchClearD = searchD.querySelector('.d-search-clear');
const searchResultsD = document.querySelector('.d-menu-search-results');
const searchResultsUlD = searchResultsD.querySelector('ul');
const searchResultsImageD = searchResultsD.querySelector('.d-search-results-image');

const searchRunD = () => {
	let keyword = searchInputD.value.toLowerCase();
	let results = [];

	// exit function if typed less than 2 characters
	if(keyword.length < 2) {
		root.classList.remove('search-is-active', 'search-has-results');
		searchResultsImageD.innerHTML = '';
		return false;
	}

	root.classList.add('search-is-active');

	window.products.forEach(item => {
		if(item.title.toLowerCase().includes(keyword)) {
			results.push(item);
		}
	});

	(results.length)
		? root.classList.add('search-has-results')
		: root.classList.remove('search-has-results');

	searchResultsUlD.innerHTML = '';
	results.forEach(item => {
		searchResultsUlD.insertAdjacentHTML('beforeend', `
			<li><a
				${item.image ?
					`data-search-result-image="${item.image}"` : ''}
				href="${item.url}">
			${item.title}
			<svg class="svg-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12"><path fill="currentColor" d="M12.42,5A87.23,87.23,0,0,1,1.07,4.71C.46,4.63,0,5.26,0,6S.48,7.35,1.07,7.27a77.62,77.62,0,0,1,11.35-.22c-.64.63-4.22,4-2,4.87.64.25,1.15-.09,1.31-.88.43-2.26,1.45-3.47,3.4-4A1.07,1.07,0,0,0,16,6,1.08,1.08,0,0,0,15.12,5a4.43,4.43,0,0,1-3.41-4C11.55.09,11-.16,10.4.09,8.25,1.07,11.7,4.27,12.42,5Z" /></svg>
			</a></li>
		`);
	});

	//  search result hover
	searchResultsUlD.querySelectorAll('[data-search-result-image]').forEach(item => {
		item.addEventListener('mouseenter', () => {
			searchResultsImageD.insertAdjacentHTML('afterBegin', `
				<span class="object-contain">
					<img src="${item.dataset.searchResultImage}">
				</span>
			`);
		});

		item.addEventListener('mouseleave', () => {
			searchResultsImageD.querySelector('.object-contain').style.animation = '0.2s fadeOut both';
		});
	});
}

searchInputD.addEventListener('keyup', searchRunD);
searchInputD.addEventListener('focus', searchRunD);

window.addEventListener('click', e => {
	if(e.target &&
		!e.target.classList.contains('d-menu-search') &&
		!e.target.closest('.d-menu-search') &&
		!e.target.classList.contains('d-menu-search-results') &&
		!e.target.closest('.d-menu-search-results')
	) {
		root.classList.remove('search-is-active');
		searchResultsImageD.innerHTML = '';
	}
});

searchClearD.addEventListener('click', () => {
	root.classList.remove('search-is-active', 'search-has-results');
	searchResultsImageD.innerHTML = '';
	searchInputD.value = '';
});

// search input
const search = document.querySelector('.menu-search');
const searchInput = search.querySelector('input');
const searchClear = search.querySelector('.search-clear');
const searchResults = document.querySelector('.menu-search-results');
const searchResultsUl = searchResults.querySelector('ul');
const searchResultsImage = searchResults.querySelector('.search-results-image');
  const cartNote = document.querySelector('#CartNote');

const searchRun = () => {
	let keyword = searchInput.value.toLowerCase();
	let results = [];

	// exit function if typed less than 2 characters
	if(keyword.length < 2) {
		root.classList.remove('search-is-active', 'search-has-results');
		searchResultsImage.innerHTML = '';
		return false;
	}

	root.classList.add('search-is-active');

	window.products.forEach(item => {
		if(item.title.toLowerCase().includes(keyword)) {
			results.push(item);
		}
	});

	(results.length)
		? root.classList.add('search-has-results')
		: root.classList.remove('search-has-results');

	searchResultsUl.innerHTML = '';
	results.forEach(item => {
		searchResultsUl.insertAdjacentHTML('beforeend', `
			<li><a
				${item.image ?
					`data-search-result-image="${item.image}"` : ''}
				href="${item.url}">
			${item.title}
			<svg class="svg-arrow-right" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12"><path fill="currentColor" d="M12.42,5A87.23,87.23,0,0,1,1.07,4.71C.46,4.63,0,5.26,0,6S.48,7.35,1.07,7.27a77.62,77.62,0,0,1,11.35-.22c-.64.63-4.22,4-2,4.87.64.25,1.15-.09,1.31-.88.43-2.26,1.45-3.47,3.4-4A1.07,1.07,0,0,0,16,6,1.08,1.08,0,0,0,15.12,5a4.43,4.43,0,0,1-3.41-4C11.55.09,11-.16,10.4.09,8.25,1.07,11.7,4.27,12.42,5Z" /></svg>
			</a></li>
		`);
	});

	//  search result hover
	searchResultsUl.querySelectorAll('[data-search-result-image]').forEach(item => {
		item.addEventListener('mouseenter', () => {
			searchResultsImage.insertAdjacentHTML('afterBegin', `
				<span class="object-contain">
					<img src="${item.dataset.searchResultImage}">
				</span>
			`);
		});

		item.addEventListener('mouseleave', () => {
			searchResultsImage.querySelector('.object-contain').style.animation = '0.2s fadeOut both';
		});
	});
}

searchInput.addEventListener('keyup', searchRun);
searchInput.addEventListener('focus', searchRun);

window.addEventListener('click', e => {
	if(e.target &&
		!e.target.classList.contains('menu-search') &&
		!e.target.closest('.menu-search') &&
		!e.target.classList.contains('menu-search-results') &&
		!e.target.closest('.menu-search-results')
	) {
		root.classList.remove('search-is-active');
		searchResultsImage.innerHTML = '';
	}
});

searchClear.addEventListener('click', () => {
	root.classList.remove('search-is-active', 'search-has-results');
	searchResultsImage.innerHTML = '';
	searchInput.value = '';
});
if(cartNote){

  cartNote.addEventListener("change", function(){
    var value = this.value;

  fetch("/cart/update.js", {
          body: JSON.stringify({
            note: value
          }),
          credentials: 'same-origin',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

          }
        });
      })


  document.addEventListener('change', function(e){
  	var el = e.target;
    
    if(el.classList.contains('gift_note_field')) {
        var parentEl = el.closest('.gift_note');
      if(parentEl) {
        var gift_note_fieldArr = parentEl.querySelectorAll('.gift_note_row .gift_note_field');
        if(gift_note_fieldArr.length) {

          var total_value = '';
          gift_note_fieldArr.forEach(function (item,index) {
       
            var field_val = item.value;
            var field_name = item.getAttribute('data-name');
            
          if(field_val.length) {
            if(total_value.length) {
              total_value =  total_value + ', ' + field_name + " " + field_val;
            } else {
               total_value = total_value + field_name + " " + field_val;
            }
            
          }
            
          });
          
          cartNote.value = total_value;
          cartNote.dispatchEvent(new Event('change', { bubbles: true }));

        }
      }
      
    }
  });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["global-press"] && !Shopify.designMode) return;
  try {
    
	const utils = window.fizzyUIUtils;

	const quotesSlider = document.querySelector('.press-quotes');
	const quotesFlkty = new Flickity( quotesSlider, {
		pageDots: false,
		prevNextButtons: false,
		adaptiveHeight: true
	});

	const logosSlider = document.querySelector('.press-logos');
	const logoSlides = utils.makeArray( logosSlider.children );
	const logosFlkty = new Flickity( logosSlider, {
		pageDots: false,
		prevNextButtons: false,
		wrapAround: false,
		cellAlign: 'center',
		watchCSS: true
	});
	let slideIndex = 0;

	const syncSliders = () => {
		logosFlkty.select( slideIndex );
		quotesFlkty.select( slideIndex );
	}

	const updateLogosSlider = (index) => {
		let previousSelectedSlide = logosSlider.querySelector('.is-selected');
		if (previousSelectedSlide) {
			previousSelectedSlide.classList.remove('is-selected');
		}
		let selectedSlide = logosSlider.children[ index ];
		selectedSlide.classList.add('is-selected');
	}

	quotesFlkty.on( 'select', function() {
		slideIndex = quotesFlkty.selectedIndex;

		if (window.innerWidth > 900) {
			updateLogosSlider(slideIndex);
		}
	});

	logosFlkty.on( 'select', function() {
		slideIndex = logosFlkty.selectedIndex;
	});

	logosSlider.addEventListener( 'click', function( event ) {
		if ( !matchesSelector( event.target, '.press-logo' ) ) {
			return;
		}

		let index = logoSlides.indexOf( event.target );
		quotesFlkty.select( index );
		logosFlkty.select( index );

		if (window.innerWidth > 900) {
			updateLogosSlider(index);
		}
	});

	setInterval(syncSliders, 250);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-applications"]) return;
  try {
    
	const applicationsSection = document.querySelector('.ingredients-applications');
	const applicationsImages = applicationsSection.querySelectorAll('.object-fit');
	const applicationsContents = applicationsSection.querySelectorAll('.applications-content-interior');

	if(window.innerWidth > 900) {
		applicationsContents.forEach((item, i) => {
			let observer = new IntersectionObserver(el => {
				if(el[0].isIntersecting === true) {
					applicationsImages.forEach((image, j) => {
						(j == i)
							? image.classList.add('is-active')
							: image.classList.remove('is-active');
					});
				}
			}, { threshold: [0.8] });// 0 = page start; 1 = page bottom

			observer.observe(item);
		});
	} else {
		applicationsImages.forEach((image, i) => {
			image.remove();
			applicationsContents[i].prepend(image.querySelector('img').cloneNode(true));
		});
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients-glossary"]) return;
  try {
    
	const glossarySection = document.querySelector('.ingredients-glossary');
	const ingredient = glossarySection.querySelectorAll('.ingredient');
	const glossaryList = glossarySection.querySelector('.glossary-list')

	ingredient.forEach(el => {
		let title = el.querySelector('.ingredient-title');
		let contentInterior = el.querySelector('.ingredient-content-interior');

		if(contentInterior.offsetHeight == 0) {
			title.style.pointerEvents = 'none';
		} else {
			title.addEventListener('click', (e) => {
				// activate current accordion
				slide('toggle', el.querySelector('.ingredient-content'));

				glossaryList.style.height = 'auto';

				(!el.classList.contains('is-active'))
					? el.classList.add('is-active') 
					: el.classList.remove('is-active');

				ingredient.forEach(el2 => {
					if(el2 != el) {
						// inactive all other accordions
						slide('up', el2.querySelector('.accordion-content'));
						el2.classList.remove('is-active');
					}
				});
			});
		}
	});


  } catch(e) { console.error(e); }
})();
})();
